import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n'

// Wijmo is loaded via script tags in public/index.html
// License key is also set there with the production multi-domain key


const app = createApp(App)
app.use(store)
app.use(router)
app.use(i18n)
app.mount('#app')